import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import FusePageSimple from "@fuse/core/FusePageSimple";
import { useThemeMediaQuery } from "@fuse/hooks";
import Card from "@mui/material/Card";
import { motion } from "framer-motion";
import { OutlinedInput, Typography } from "@mui/material";
import _ from "@lodash";
import * as yup from "yup";
import SearchIcon from "@mui/icons-material/Search";

import { useTranslation } from "react-i18next";
import YouthMailListItem from "./parent-message-list";
import { authDataService } from "../../services/data/auth.data.service";
import DraftsIcon from "@mui/icons-material/Drafts";
import MailDetails from "./message";

const Root: any = styled(FusePageSimple)(({ theme }) => ({
  "& .FusePageSimple-header": {
    backgroundColor: theme.palette.background.paper,
    borderBottomWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.divider,
    "& > .container": {
      maxWidth: "100%",
    },
  },
}));

const schema = yup.object().shape({
  to: yup
    .string()
    .required("You must enter an e-mail")
    .email("You must enter a valid e-mail."),
});

const mailData: MailData[] = [
  {
    id: 1,
    username: "Ramesh Vithana",
    subject:
      "Registration Now Open: 2025 Marion Barry Summer Youth Employment Program (MBSYEP)",
    date: "07/07/2025",
    content: `Dear Parent, 
    
    We are excited to announce that registration for the 2025 Marion Barry Summer Youth Employment Program (MBSYEP) is now officially open!
    
    MBSYEP is a signature initiative of the District of Columbia Department of Employment Services (DOES), providing young people in the District with valuable summer work experience, professional development, and career exposure.
    
    ⦿ What You Need to Know

      • If your child is interested in participating this year, they must register online and complete all steps in the enrollment process through the CODICE Youth Program Management System (CYPMS).
      • Registration is now open and will close on 08/31/2025.
      • Once your child applies, you may be asked to log in as a parent/guardian to provide your consent.

    ⦿ How to Get Started
    Please encourage your child to:
    
      • Log in to their CYPMS account (or create one if new).
      • Complete the MBSYEP application form.
      • Upload any required documents and complete the orientation module.

    If your child has already identified you as their guardian, you will receive further instructions to confirm your consent through the Parent Portal.
    
    We look forward to your continued partnership in supporting youth success in the District. If you have questions or need support, please contact us at support@ypms.com/ 22 222 222.
    
    Sincerely,
    Office of Youth Programs,
    District of Columbia Department of Employment Services (DOES)`,
    avatar: "assets/images/avatars/male-12.jpg",
    url: "email/1",
  },
];

export default function ParentMessages() {
  const isMobile = useThemeMediaQuery((theme: any) =>
    theme.breakpoints.down("lg")
  );
  const [leftSidebarOpen, setLeftSidebarOpen] = useState(!isMobile);

  const [selectedEmail, setSelectedEmail] = useState<MailData>();

  useEffect(() => {
    setLeftSidebarOpen(!isMobile);
  }, [isMobile]);

  const { t } = useTranslation("YouthMessages");

  return (
    <Root
      content={
        <>
          {selectedEmail === undefined ? (
            <Card
              variant="outlined"
              className="m-24 w-full h-full flex items-center justify-center "
            >
              <DraftsIcon
                className="icon-size-128 mb-16 h-full"
                color="disabled"
              />
            </Card>
          ) : (
            <Card variant="outlined" className="m-24 w-full overflow-auto ">
              <MailDetails {...selectedEmail} />
            </Card>
          )}
          <b></b>
        </>
      }
      leftSidebarContent={
        <div className="px-12 py-24 min-h-6xl mr-8">
          <Typography
            component={motion.span}
            initial={{ x: -20 }}
            animate={{ x: 0, transition: { delay: 0.2 } }}
            className="text-4xl font-extrabold tracking-tight items-center leading-none mt-24 mb-24 ml-32 mr-32"
          >
            {t("MAIL_BOX")}
          </Typography>

          <OutlinedInput
            className="flex flex-1 items-center mt-24 px-16 rounded-full"
            fullWidth
            placeholder="Search here..."
            startAdornment={<SearchIcon />}
            inputProps={{
              "aria-label": "Search",
            }}
            size="small"
          />

          <div className="mb-24">
            {mailData.map((item: MailData) => (
              <Link
                to=""
                key={item.id}
                style={{ textDecoration: "none" }}
                onClick={() => {
                  setSelectedEmail(item);
                }}
              >
                <YouthMailListItem {...item} />
              </Link>
            ))}
          </div>
        </div>
      }
      leftSidebarOpen={leftSidebarOpen}
      scroll="content"
    />
  );
}
